// Single entry point for data access. Pages and the auth layer import `api`
// from here so swapping mock ↔ real is one switch. Feature APIs (auth, CPL, …)
// are composed so each mode exposes the same method surface.

import { realApi } from './http';
import { mockApi } from './mock';
import { cplRealApi } from './cplHttp';
import { cplMockApi } from './cplMock';
import { jacketRealApi } from './jacketHttp';
import { jacketMockApi } from './jacketMock';
import { rateRealApi } from './rateHttp';
import { rateMockApi } from './rateMock';
import { accountRealApi } from './accountHttp';
import { accountMockApi } from './accountMock';
import { adminRealApi } from './adminHttp';
import { adminMockApi } from './adminMock';
import { docRealApi } from './docHttp';
import { docMockApi } from './docMock';
import { uploadRealApi } from './uploadHttp';
import { uploadMockApi } from './uploadMock';

const USE_MOCK =
  import.meta.env.VITE_USE_MOCK === '1' || import.meta.env.VITE_USE_MOCK === 'true';

export const api = USE_MOCK
  ? { ...mockApi, ...cplMockApi, ...jacketMockApi, ...rateMockApi, ...accountMockApi, ...adminMockApi, ...docMockApi, ...uploadMockApi }
  : { ...realApi, ...cplRealApi, ...jacketRealApi, ...rateRealApi, ...accountRealApi, ...adminRealApi, ...docRealApi, ...uploadRealApi };
export type Api = typeof api;

export { HttpError } from './http';
export { pdfUrls } from './docHttp';
